var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M19.169 5.719c.407-.419 1.077-.427 1.495-.02.388.38.423.984.1 1.403l-.081.093-10.531 10.798c-.385.395-1.001.424-1.42.086l-.093-.084-4.854-4.952c-.408-.417-.402-1.087.015-1.495.388-.38.993-.401 1.405-.069l.091.084 4.096 4.18 9.777-10.024z","transform":"translate(-989 -77) translate(397 64) translate(592 13)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }